import { InjectionKey } from "vue";
import { WorkflowState } from "./useWorkflow";

export const workflowInjectKey = Symbol() as InjectionKey<WorkflowState>;
